/*
*###############################################################################
*Module Name                   : GroupMasterSetupContent.js                    #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               :  T A C Priyashad                              #
*Date                          : Wednesday, September 1st 2021, 9:24:47 am     #
*Copyright (c) 2021 myPOS Software Solution (pvt Ltd.)                         #
*###############################################################################
*/

import React, { useState } from "react"

import {
  CardText,
  Row,
  Col,
  Button,
  Alert
} from "reactstrap"
import DPTextBox from "framework/components/DPTextBox"
import DPSwitch from "framework/components/DPSwitch"
import DPTextBoxforgrid from "../../../framework/components/DPTextBoxforgrid"
import DPDropDown from "framework/components/DPDropDown"
import { Text, Numeric } from "../../../framework/validators/TextValidation" // Textbox input validations
import DPSearchBoxDynamic from "framework/components/DPSearchBoxDynamic"
import ReactPaginate from "react-paginate"


const GroupMasterSetupContent = ({
  strFileNo,
  SetFileCode,
  strFilename,
  SetFilename,
  strMenuNo,
  SetMenuNo,
  disabledCode,
  disabledDesc,
  intCodeLength,
  SetCodeLength,
  intDescLength,
  SetDescLength,
  setupArray,
  handleAddRowNested,
  RemoveRow,
  modelTrigger,
  GetSelectRow,
  modelOpen,
  onCodeBlur,
  show,
  AlertColor,
  AlertMsg,
  ErrorMsg,
  menuCode,
  setSetupArray,
  disabled,
  addNew,
  currentPage,
  setCurrentPage
}) => {

  const [HeadColumns, setHeadColumns] = useState([])
  const [groupFilter, SetGroupFilter] = useState("a")
  const ApiURL = window.Links.ApiURL

  const [postsPerPage] = useState(10)

  const indexOfLastPost = currentPage * postsPerPage
  const indexOfFirstPost = indexOfLastPost - postsPerPage
  const currentPosts = setupArray.slice(indexOfFirstPost, indexOfLastPost);

  const handlePageClick = (event) => {
    setCurrentPage(event.selected + 1);
  };

  async function tog_backdrop() {
    modelTrigger();
  }

  const defaultSorted = [{
    dataField: 'id',
    order: 'asc'
  }];



  const changeRowValueChanges = async (value, id, element) => {

    const objectIndex = setupArray.findIndex(obj => obj.id === id);
    const newObject = { ...setupArray[objectIndex], [element]: value };
    setSetupArray(prevDataRow => {
      const newDataRow = [...prevDataRow];
      newDataRow[objectIndex] = newObject;
      return newDataRow;
    });
  };


  async function handleObjectChange(row, id) {

    const objectIndex = setupArray.findIndex(obj => obj.id === id);

    const newDataRow = [...setupArray];
    newDataRow[objectIndex] = row;

    setSetupArray(newDataRow);
  }


  return (
    <React.Fragment>
      <div style={{ paddingTop: "1rem" }}>
        <Row>
          {show ? (
            <Alert color={AlertColor} role="alert">
              {AlertMsg}
              <br />
              <small>{ErrorMsg}</small>
            </Alert>
          ) : null}
          <Col sm="12">
            <CardText className="mb-0">
              <Row>
                <Col sm={12} md={8} className="mb-4-sm">
                  <DPTextBox
                    rowClass="mb-4-sm"
                    labelText="Group Number"
                    textType="text"
                    maxLength="40"
                    value={strFileNo}
                    onChange={SetFileCode}
                    disabled={disabledCode}
                    onBlur={onCodeBlur}
                  />
                  <DPTextBox
                    rowClass="mb-4-sm"
                    labelText="Group Description"
                    textType="text"
                    maxLength="40"
                    onChange={SetFilename}
                    value={strFilename}
                    disabled={disabledDesc}
                  />

                  <DPTextBox
                    rowClass="mb-4-sm"
                    labelText="Menu Code"
                    textType="text"
                    maxLength="40"
                    onChange={SetMenuNo}
                    value={strMenuNo}
                    disabled={true}
                  />
                  <DPTextBox
                    rowClass="mb-4-sm"
                    labelText="Code Length"
                    textType="text"
                    defaultValue="0.0"
                    value={intCodeLength}
                    onChange={SetCodeLength}
                    disabled={disabledDesc}
                  />
                  <DPTextBox
                    rowClass="mb-4-sm"
                    labelText="Description Length"
                    textType="text"
                    defaultValue="0.0"
                    value={intDescLength}
                    onChange={SetDescLength}
                    disabled={disabledDesc}
                  />
                </Col>
                <Col sm={12} md={1} className="mb-4-sm">
                  <Button
                    onClick={() => {
                      tog_backdrop()
                    }}
                    color="success"
                    className="btn-sm"
                    disabled={disabledCode}
                  >
                    <i
                      className="mdi mdi-search-web"
                      style={{ fontSize: "12px" }}
                    ></i>
                  </Button>
                </Col>

                <p></p>
                <Col sm={12} md={12} className="mb-4-sm">
                  <table style={{ fontSize: "11px" }} id={"tblGSDet"}>
                    <thead className="table-sm">
                      <tr>
                        <th>Id </th>
                        <th>Display Name </th>
                        <th>Type</th>
                        <th>Length</th>
                        <th>Mandatory</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentPosts.map((formRow, key) => (
                        <TableRow
                          FormRow={formRow}
                          Key={key}
                          RemoveRow={RemoveRow}
                          disabled={disabledDesc}
                          disableGrid={disabled}
                          changeRowValueChanges={changeRowValueChanges}
                          handleObjectChange={handleObjectChange}
                          disableDelete={addNew}
                        />
                      ))}
                    </tbody>
                  </table>
                  <Row sm={12} md={12} className="mb-4-sm">
                    <Col>
                      <Button
                        onClick={() => {
                          handleAddRowNested()
                        }}
                        color="success"
                        className="mt-1"
                        disabled={disabledDesc}
                        size="sm"
                      >
                        <i className="mdi mdi-hospital" style={{ fontSize: "12px" }}></i>
                      </Button>
                    </Col>
                    <Col>
                      <ReactPaginate
                        previousLabel={'Previous'}
                        nextLabel={'Next'}
                        breakLabel={'...'}
                        pageClassName="page-item"
                        pageLinkClassName="page-link"
                        previousClassName="page-item"
                        previousLinkClassName="page-link"
                        nextClassName="page-item"
                        nextLinkClassName="page-link"
                        breakClassName="page-item"
                        breakLinkClassName="page-link"
                        pageCount={Math.ceil(setupArray.length / postsPerPage)}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageClick}
                        forcePage={currentPage - 1}
                        renderOnZeroPageCount={null}
                        activeClassName={'active'}
                        activeLinkClassName={'page-link'}
                        containerClassName={'pagination justify-content-end pagination-sm'}
                      />
                    </Col>
                  </Row>
                </Col>

                <DPSearchBoxDynamic
                  searchData={[]}
                  columns={HeadColumns}
                  defaultSorted={defaultSorted}
                  mainTitle={"Group Master Setup Search"}
                  SelectType={"checkbox"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                  isOpen={modelOpen}
                  toggle={modelTrigger}
                  getSelect={GetSelectRow}
                  APIURL={ApiURL}
                  URLPath={"GRPSETUP"}
                  MenuCode={menuCode}
                  KeyVal={"GRP"}
                  searchBy={"GS_FILENO"}
                  FilterStr={groupFilter}
                />

              </Row>
            </CardText>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  )
}
export default GroupMasterSetupContent

const TableRow = ({ FormRow, Key, RemoveRow, disabled, changeRowValueChanges, handleObjectChange, disableGrid, disableDelete }) => {


  const [typeGroup, SettypeGroup] = useState([{ label: "Text", value: "0" }, { label: "Numeric", value: "1" }, { label: "Date/Time", value: "2" }, { label: "Yes/No", value: "3" }])


  //* End Code Validation   */
  return (
    <tr key={FormRow.id}>
      <td>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              id={"txtfieldId" + Key}
              textType="text"
              maxLength="8"
              disabled={true}
              value={FormRow.code}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              id={"txtfieldName" + Key}
              labelText="Code"
              textType="text"
              maxLength="50"
              disabled={disabled}
              value={FormRow.desc}
              onChange={e => {
                var textValue = Text(e.target, 50, true, false, "any", true)
                changeRowValueChanges(textValue, FormRow.id, "desc")
              }}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td style={{ width: "200px" }}>
        <DPDropDown
          labelText=""
          rowClass="mb-4-sm"
          id={"txtType" + Key}
          optionGroup={typeGroup}
          selectedGroup={FormRow.type}
          onChange={async (e) => {
            var newRow = FormRow
            newRow.type = e["value"]
            newRow.fieldLen = e["value"] == "0" ? "" : e["value"] == "-1" ? "" : "1"
            handleObjectChange(newRow, FormRow.id)
          }}
          disabled={disabled}
          labelHide={true}
        />
      </td>
      <td>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              defaultValue="0"
              disabled={disabled}
              value={FormRow.fieldLen}
              id={"txtfieldLen" + Key}
              onChange={e => {
                if (FormRow.type == 0) {
                  changeRowValueChanges(Numeric(e.target, 4, 0, false) == 0 ? "" : Numeric(e.target, 4, 0, false), FormRow.id, "fieldLen")
                }
              }}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td>
        <Row className="mb-0">
          <Col md="12">
            <DPSwitch
              checked={FormRow.req}
              onChange={(e) => changeRowValueChanges(e, FormRow.id, "req")}
              id={"txtfieldReq" + Key}
              disabled={disabled}
            ></DPSwitch>
          </Col>
        </Row>
      </td>
      <td>
        <Row className="mb-0">
          <Col md="1">
            <Button
              outline
              color="danger"
              disabled={disabled ? true : disableDelete ? false : true}
              id={"btnDelete" + Key}
              onClick={e => {
                RemoveRow(FormRow.id)
              }}
              size="sm">
              <i
                className="mdi mdi-delete"
                style={{ fontSize: "12px" }}
              ></i>
            </Button>
          </Col>{" "}
        </Row>
      </td>
    </tr>
  )
}
